import React from 'react';
import T from 'i18n-react';
import FollowDescDialog from '../Businesses/Follow/FollowDescDialog';

const NearbyDialog = React.forwardRef((props, ref) => (
  <FollowDescDialog
    title={T.translate('plans.nearby.dialog1')}
    text={T.translate('plans.nearby.dialog2')}
    footer={false}
    ref={ref}
  />
));

export default NearbyDialog;
